import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import { GenericHeightWeightQuestionFieldAnswers } from '../../Generic/HeightWeight/question';

const questionsModel = [
  {
    field: 'enclomiphene_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'enclomiphene_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    extras: { sendToBeluga: false },
    answer: {},
    reject: true,
    type: 'info',
    isLast: true
  },
  {
    class: 'ineligible',
    field: 'enclomiphene_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    extras: { sendToBeluga: false },
    answer: {},
    type: 'info',
    reject: true,
    isLast: true
  },
  {
    field: 'enclomiphene_sexAssignedAtBirth',
    label: 'What was your sex assigned at birth?',
    extras: { sendToBeluga: false },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Male',
          key: 'male'
        },
        {
          value: 'Female',
          key: 'female'
        }
      ]
    }
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'enclomiphene_height',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'enclomiphene_height'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'enclomiphene_weight',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'enclomiphene_weight'
    }
  },
  {
    label:
      'Have you had a physical exam with a healthcare provider in the past 5 years?',
    field: 'enclomiphene_physicalExam',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_goodHealth',
          value: 'Yes, I am in good health'
        },
        {
          key: 'yes_problems',
          value: 'Yes, but they found problems'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please explain any issues during your last physical exam',
    field: 'enclomiphene_physicalExam_issues',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'enclomiphene_physicalExam_issues'
    }
  },
  {
    label: 'Have you had any hospitalizations within the last year?',
    field: 'enclomiphene_hospitalizations',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes'
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please provide further details',
    field: 'enclomiphene_hospitalizations_details',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'enclomiphene_hospitalizations_details'
    }
  },
  {
    label:
      'Do any of the following conditions or situations apply to you? (Select all that apply)',
    field: 'enclomiphene_conditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'enclomiphene_liverDisease',
          value: 'Liver disease'
        },
        {
          key: 'enclomiphene_kidneyDisease',
          value: 'Chronic kidney disease'
        },
        {
          key: 'enclomiphene_congestiveHeartFailure',
          value: 'Congestive heart failure'
        },
        {
          key: 'enclomiphene_coronaryArteryDisease',
          value: 'Coronary artery disease'
        },
        {
          key: 'enclomiphene_uncontrolledSleepApnea',
          value: 'Uncontrolled or untreated sleep apnea'
        },
        {
          key: 'enclomiphene_historyOfBloodClot',
          value: 'History of a blood clot'
        },
        {
          key: 'enclomiphene_testicularCancer',
          value: 'Testicular cancer (past or present)'
        },
        {
          key: 'enclomiphene_prostateCancer',
          value: 'Prostate cancer (past or present)'
        },
        {
          key: 'enclomiphene_pituitaryTumor',
          value: 'Tumor in the pituitary gland (past or present)'
        },
        {
          key: 'enclomiphene_estrogenDependentTumor',
          value:
            'Estrogen-dependent tumor such as breast cancer or other (past or present)'
        },
        {
          key: 'enclomiphene_earlyPuberty',
          value: 'Early puberty'
        },
        {
          key: 'enclomiphene_gynecomastia',
          value: 'Gynecomastia (breast enlargement in men)'
        },
        {
          key: 'enclomiphene_shrinkingTesticles',
          value: 'Shrinking testicles or small testes'
        },
        {
          key: 'enclomiphene_signsOfEnlargedProstate',
          value:
            'Signs and symptoms of an enlarged prostate (increased urination at night, trouble starting urinary stream, urinating many times daily, urinary urgency, inability to pass urine, or weak urine flow)'
        },
        {
          key: 'enclomiphene_none',
          uncheckOthers: true,
          value: 'None of the above'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about the condition(s) you selected.',
    field: 'enclomiphene_conditions_details',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'enclomiphene_conditions_details'
    }
  },

  {
    field: 'enclomiphene_symptoms',
    label:
      'Have you experienced any of the following symptoms? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Decreased sex drive/libido',
          key: 'decreased_libido'
        },
        {
          value: 'Fatigue or lack of energy',
          key: 'fatigue'
        },
        {
          value: 'Mood changes like increased irritability or depression',
          key: 'mood_changes'
        },
        {
          value: 'Difficulty concentrating',
          key: 'difficulty_concentrating'
        },
        {
          value: 'Reduced muscle mass or strength',
          key: 'reduced_muscle'
        },
        {
          value: 'Increased body fat',
          key: 'increased_body_fat'
        },
        {
          value: 'Decreased body hair',
          key: 'decreased_body_hair'
        },
        {
          value: 'Decreased sense of well-being',
          key: 'decreased_wellbeing'
        },
        {
          value: 'Erectile dysfunction',
          key: 'erectile_dysfunction'
        },
        {
          value: 'Other',
          key: 'other'
        },
        {
          value: 'I do not experience any of these',
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'enclomiphene_symptomsDetails',
    label: 'Please tell us more about your symptoms',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'enclomiphene_symptomsDetails'
    }
  },
  {
    field: 'enclomiphene_symptomsDuration',
    label: 'How long have you experienced the symptoms you selected?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 2,
      name: 'enclomiphene_symptomsDuration'
    }
  },
  {
    field: 'enclomiphene_previousTreatment',
    label: 'Have you ever been treated for hypogonadism or low testosterone?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: "Yes I'm currently on treatment or have taken it in the past",
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_treatmentDetails',
    label:
      'Please provide more information, including your treatment (injections, gels, pellets, etc.) and approximate dates of treatment.',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'enclomiphene_treatmentDetails'
    }
  },
  {
    field: 'enclomiphene_previousDose',
    label: 'What dose did you use or are you using?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 2,
      name: 'enclomiphene_previousDose'
    }
  },
  {
    field: 'enclomiphene_lastUseDate',
    label:
      'When did you last use this product? Please provide the exact date (ie: 11/21/2025)',
    type: 'info',
    answer: {
      type: 'text',
      rows: 1,
      name: 'enclomiphene_lastUseDate'
    }
  },
  {
    field: 'enclomiphene_doseSatisfaction',
    label: 'Are you or were you happy with that dose?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes, I was happy with this',
          key: 'satisfied'
        },
        {
          value: 'No, it was too strong',
          key: 'too_strong'
        },
        {
          value: "No, it wasn't effective for me",
          key: 'not_effective'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_previousComplications',
    label: 'Did you have any complications from treatment?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_previousSideEffects',
    label: 'Please tell us more about the side effects that you experienced',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'enclomiphene_previousSideEffects'
    }
  },
  {
    field: 'enclomiphene_currentlyTakingEnclomiphene',
    label:
      'Are you currently taking Enclomiphene or similar products such as Clomid?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: "Yes I'm currently on treatment",
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_currentComplications',
    label: 'Did you have any complications from treatment?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes I have side effects',
          key: 'yes_side_effects'
        },
        {
          value: "No I'm doing well on this product",
          key: 'doing_well'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_currentSideEffects',
    label: 'Please tell us more about the side effects that you experienced',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'enclomiphene_currentSideEffects'
    }
  },
  {
    field: 'enclomiphene_currentDose',
    label: 'What is your current dose of enclomiphene?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: "I'm taking 12.5mg",
          key: '12_5mg'
        },
        {
          value: "I'm taking 25mg",
          key: '25mg'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_currentDoseSatisfaction',
    label: 'Are you happy with that dose?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes, I was happy with this dose',
          key: 'satisfied'
        },
        {
          value: 'No, it is too strong',
          key: 'too_strong'
        },
        {
          value: "No, it wasn't effective for me",
          key: 'not_effective'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_polycythemia',
    label:
      'Do you have polycythemia vera, an elevated blood count (hemoglobin/hematocrit), or has your provider recommended that you undergo phlebotomy (donate blood) for medical reasons?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_hypertension',
    label: 'Do you have hypertension (high blood pressure)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_bpControlled',
    label: 'Is your blood pressure well controlled?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_averageBP',
    label: 'What is your average blood pressure reading?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 1,
      name: 'enclomiphene_averageBP'
    }
  },
  {
    field: 'enclomiphene_tobacco',
    label: 'Do you smoke, vape, or use tobacco products?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_tobaccoFrequency',
    label: 'How often do you use these products?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'A few times per day',
          key: 'few_times_daily'
        },
        {
          value: 'Several times per day',
          key: 'several_times_daily'
        },
        {
          value: 'Weekly',
          key: 'weekly'
        },
        {
          value: 'Occasionally',
          key: 'occasionally'
        },
        {
          value: 'Rarely',
          key: 'rarely'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_alcohol',
    label: 'Do you consume alcohol?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_currentlyHaveLabs',
    label:
      'Do you have an image  of previous bloodwork done, within the last 4 months?',
    type: 'select',
    extras: { sendToBeluga: false },
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_InitialLabsUpload',
    label: 'Image Request:',
    educationSlide:
      'To ensure the highest quality of care during your telemedicine consultation, we kindly request your assistance in providing an image of your initial or most recent labs obtained upon diagnosis that demonstrate your testosterone levels. Please be assured that these images will remain private and will not be shared. The physician will use the picture solely for assessment purposes to better understand your health condition. If you are unable to upload recent lab results OR if your labs were abnormal, you will be required to complete blood testing before proceeding with treatment. Thank you for your cooperation and understanding in helping to provide comprehensive care remotely.',
    type: 'file_upload',
    accepts: ['application/pdf', 'image/png', 'image/jpeg'],
    answer: [
      {
        resourceId: 'enclomiphene_InitialLabsUpload',
        buttonLabel: 'Upload Image/PDF'
      }
    ]
  },
  {
    field: 'enclomiphene_alcoholFrequency',
    label: 'How much and how often do you drink?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have 3 or more drinks per day',
          key: 'three_plus_daily'
        },
        {
          value: 'I have 1-2 drinks per day',
          key: 'one_two_daily'
        },
        {
          value: 'I have a few drinks per week',
          key: 'few_weekly'
        },
        {
          value: 'I will occasionally drink',
          key: 'occasionally'
        },
        {
          value: 'I rarely drink',
          key: 'rarely'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_exercise',
    label: 'Do you engage in regular physical exercise?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_additionalInfo',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'enclomiphene_additionalInfo'
    }
  },
  {
    field: 'enclomiphene_consentTruthfulness',
    label: 'Consent (Truthfulness):',
    type: 'select',
    educationalSlide:
      'Please attest to the following confirming that all information you have provided to us is true and complete.\n\nConsent: I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'enclomiphene_identityVerification',
    label: 'Identity Verification',
    type: 'info',
    educationalSlide:
      "Upload a photo of a valid government-issued photo ID such as a driver's license or passport which has your picture, name and date of birth clearly visible. If applicable, upload a photo of the front and the back especially when using a military ID as your date of birth is on the back of the card. Make sure the photo is clear and legible.",
    answer: {
      type: 'text',
      rows: 1,
      name: 'enclomiphene_identityVerification'
    }
  },
  {
    field: 'enclomiphene_consentTreatment',
    label: 'Consent (Enclomiphene Treatment):',
    type: 'select',
    educationalSlide:
      "Enclomiphene is a medication that may be prescribed to increase testosterone levels in men experiencing symptoms of low testosterone. While it is FDA-approved for other uses, its application for treating low testosterone in men is considered off-label, meaning it is not specifically approved by the FDA for this purpose, though your healthcare provider may prescribe it when deemed appropriate. The purpose of this consent form is to ensure that you understand the reasons for using enclomiphene, the potential benefits and risks, the monitoring plan, and your responsibilities during treatment. Please read this document carefully.\n\nYou have been diagnosed with symptoms suggestive of hypogonadism, such as fatigue, decreased libido, erectile dysfunction, mood changes, and reduced muscle mass. You may have low testosterone levels or testosterone levels within the normal range but with consistent symptoms, which is suggestive of functional hypogonadism. Enclomiphene is being considered as a treatment option to potentially improve your symptoms by stimulating your body's natural production of testosterone. As previously mentioned, the use of enclomiphene to increase testosterone levels in men is off-label. Although this medication is legally prescribed, it is being used in a way that differs from its original FDA-approved indications.\n\nPotential Benefits of Enclomiphene\nThe potential benefits of enclomiphene include:\nIncreased testosterone levels\nImproved energy and mood\nEnhanced libido and sexual function\nIncreased muscle mass and strength\nPotential improvement in fertility since enclomiphene does not suppress natural testosterone production\n\nPotential Risks and Side Effects\nPotential risks and side effects include:\nCommon risks:\nIncreased risk of blood clots\nMood changes\nGynecomastia\nElevated red blood cell count\nHeadaches, nausea, and visual disturbances\nProstate enlargement\nWorsening of pre-existing sleep apnea\nSerious but less common risks:\nExacerbation of undiagnosed prostate cancer\nSevere cardiovascular events, such as heart attack or stroke\nLiver toxicity\n\nMonitoring Plan\nTo ensure safety and effectiveness, regular monitoring is required. This includes:\nInitial baseline testing to measure testosterone levels, liver function, and estradiol levels\nOngoing monitoring with blood tests to assess treatment efficacy and safety\nRegular follow-up visits to discuss progress, side effects, and adjustments to your treatment plan\n\nAlternative Treatments\nAlternative treatments include:\nTraditional testosterone replacement therapy (injections, gels, or patches)\nLifestyle modifications (exercise, diet, and stress management)\nOther medications to improve testosterone levels\n\nPatient Responsibilities\nAs a patient, you are responsible for:\nAttending all scheduled follow-up appointments\nReporting any side effects or new symptoms to your healthcare provider\nAdhering to the prescribed dosing regimen\nUndergoing all required laboratory tests and examinations as part of the monitoring plan\n\nBy selecting below, you understand the potential risks and benefits of using enclomiphene and the off-label nature of this treatment. You agree to follow the monitoring plan and inform your healthcare provider of any side effects or concerns.",
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read and understand the information and I DO NOT wish to proceed',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the information and wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  }
] as const;

export type EnclomipheneQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModel>
> &
  GenericHeightWeightQuestionFieldAnswers;
export default questionsModel;
